import { useState } from "react";
import type { RotationFailure } from "../lib/useAttentionPoll";

interface Props {
  item: RotationFailure;
  onResolved: () => void;
}

const ANGLES: ReadonlyArray<0 | 90 | 180 | 270> = [0, 90, 180, 270];

export function RotationQuickFix({ item, onResolved }: Props) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const pick = async (angle: number) => {
    if (busy) return;
    setBusy(true);
    setErr(null);
    try {
      const res = await fetch(
        new URL(`api/cards/${item.kind}/${item.card_id}/resolve-orientation`, document.baseURI).toString(),
        {
          method: "POST",
          credentials: "same-origin",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({ angle }),
        },
      );
      if (!res.ok) throw new Error(await res.text());
      onResolved();
    } catch (e: any) {
      setErr(e.message || String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rotation-quickfix">
      <div className="rotation-quickfix-head">
        <strong>📄 {item.filename}</strong>
        {item.source_page_index != null && <span className="muted">· Seite {item.source_page_index}</span>}
      </div>
      <div className="rotation-quickfix-tiles">
        {ANGLES.map((angle) => (
          <button
            key={angle}
            type="button"
            className="rotation-tile"
            disabled={busy}
            onClick={() => pick(angle)}
            title={`Seite um ${angle}° drehen`}
          >
            <img
              src={new URL(`api/cards/${item.kind}/${item.card_id}/preview?rotate=${angle}&dpi=96`, document.baseURI).toString()}
              alt={`Vorschau ${angle}°`}
              loading="lazy"
              className="rotation-tile-img"
            />
            <div className="rotation-tile-label">{angle}°</div>
          </button>
        ))}
      </div>
      {err && <div className="error">{err}</div>}
    </div>
  );
}
